import Image from 'next/image';
import { match } from 'ts-pattern';

import { getCdnUrl } from '~/domains/assets/utils/getCdnUrl';

import dt from '../../../testing.const';

import { useStyles } from './WhalersClubTierBadge.styles';


function WhalersClubTierBadge({ tierIndex }: { tierIndex: number | null }) {
  const { classes } = useStyles();

  const imgSrc = match(tierIndex)
    .with(0, () => getCdnUrl('/images/loyalty/WhalersTierBronze.png'))
    .with(1, () => getCdnUrl('/images/loyalty/WhalersTierSilver.png'))
    .with(2, () => getCdnUrl('/images/loyalty/WhalersTierGold.png'))
    .with(3, () => getCdnUrl('/images/loyalty/WhalersTierDiamond.png'))
    .otherwise(() => getCdnUrl('/images/loyalty/WhalersTierBase.png'));

  return (
    <div className={classes.container} data-test-id={dt.detailModal.tierBadge}>
      <Image className={classes.image} src={imgSrc} alt={"Whaler's Club Tier badge"} width={225} height={250} />
    </div>
  );
}

export default WhalersClubTierBadge;
